/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from "@angular/common/http";
import {Observable} from "rxjs";
import {StrictHttpResponse} from "../../strict-http-response";
import {RequestBuilder} from "../../request-builder";
import {filter, map} from "rxjs/operators";

export interface FilesGetParams {
    guid: string;
}

export function filesGet(http: HttpClient, rootUrl: string, params: FilesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(rootUrl, filesGet.PATH, 'get');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.path('guid', params.guid, {"style":"simple"});

    return http.request(
        rb.build({ responseType: 'blob', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Blob>;
        })
    );
}

filesGet.PATH = '/api/v1/files/{guid}';
